import { WordingMultiFitnessYogaPilates } from '@/types';

export const MULTI_FITNESS_YOGA_PILATES_WORDING_SK: WordingMultiFitnessYogaPilates = {
  components_header_media_content: 'Fitness',
  components_header_media_1: 'Pre mužov',
  components_header_media_2: 'Pre ženy',
  components_header_media_multi_content_2: 'Jóga',
  components_header_media_multi_content_3: 'Pilates',
  hero_text: 'Trénujte múdrejšie, cíťte sa lepšie.',
  hero_button_text: 'Začnite teraz',
  components_ressources_subheader_text: 'Sprievodcovia a tipy',
  components_ressources_span_text: 'Kombinuje prirodzené zameranie jogy, kontrolovanú presnosť pilatesu a dynamickú výzvu silového tréningu na podporu všestranného a zdravého životného štýlu.',
  components_ressources_card_1_title: 'Tipy na jogu',
  components_ressources_card_1_text: 'Stručný návod pre lepšiu rovnováhu, dýchanie a plynulosť pohybu.',
  components_ressources_card_2_title: 'Tipy na pilates',
  components_ressources_card_2_text: 'Jednoduché tipy na posilnenie svalov trupu a zlepšenie kontroly.',
  components_notes_and_google_title_1: 'Budujte silu',
  components_notes_and_google_title_2: 'Jóga pokoja',
  components_notes_and_google_title_3: 'Pilatesové jadro',
  media_content_section_multi_1_subheader_text: 'Tréningové videá',
  media_content_section_multi_2_subheader_text: 'Videá o joge',
  media_content_section_multi_3_subheader_text: 'Videá o pilatese',
  text_media_1: 'Muži',
  text_media_2: 'Ženy',
  page_media_content_menu_biceps: 'Bicepsy',
  page_media_content_menu_triceps: 'Triceps',
  page_media_content_menu_back: 'Späť',
  page_media_content_menu_chest: 'Hrudník',
  page_media_content_menu_legs: 'Nohy',
  page_media_content_menu_shoulders: 'Ramená',
  page_media_content_menu_abdominals: 'Brušné svaly',
  components_text1_subheader_text: 'Zdravá strava pre váš aktívny život',
  components_text1_span_text: 'Zdravé recepty, ktoré podporia váš tréning a zlepšia vašu pohodu.',
  components_footer_text: 'Posilnite si telo, vyvážte si myseľ a hýbte sa zmysluplne – vaše miesto pre posilňovňu, jogu a pilates.',
};